import { render, staticRenderFns } from "./agentDistributionBill.vue?vue&type=template&id=ddfc9600&scoped=true&"
import script from "./agentDistributionBill.vue?vue&type=script&lang=js&"
export * from "./agentDistributionBill.vue?vue&type=script&lang=js&"
import style0 from "./agentDistributionBill.vue?vue&type=style&index=0&id=ddfc9600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfc9600",
  null
  
)

component.options.__file = "agentDistributionBill.vue"
export default component.exports